import React, {FC, useState} from "react";
import {IAuthAdminProps} from "../block-auth.type";
import Button from "/react4xp/mixins/ui/button/button";
import {logout} from "../actions";
import { localize } from "/react4xp/mixins/helpers";

const AuthLoggedIn: FC<IAuthAdminProps> = (props: IAuthAdminProps) => {
    const [loading, setLoading] = useState(false);

    const openAdminSite = () => {
        open('/site/ru/master/isna-portal-admin', '_self');
    };

    const logoutUser = () => {
        setLoading(true);

        logout().then(
            () => location.reload()
        ).catch(() => setLoading(false));
    };

    return (
        <div className="text-start">
            <div>{localize('block-auth-login', props.translations)}: {props.login}</div>
            <div className="my-3">{localize('block-auth-roles', props.translations)} {props.roles}</div>
            {props.roles.length > 0 && (
                <div className="my-3">
                    <Button type="primary" color='gold' onClick={openAdminSite}>
                        {localize('block-auth-log-in', props.translations)}
                    </Button>
                </div>
            )}
            <div>
                <Button onClick={logoutUser} loading={loading}>
                    {localize('block-auth-log-out', props.translations)}
                </Button>
            </div>
        </div>
    );
};

export default AuthLoggedIn;
